import { useMemo } from 'react';
import { Select } from 'antd';
import { observer } from 'mobx-react-lite';

import { TTerminalProfile } from '../../core/profiles';

type UiSelectTerminalProfile = {
  items?: TTerminalProfile[];
  value?: TTerminalProfile;
  loading?: boolean;
  onChange: (value: TTerminalProfile) => void;
};

const defaultValue: TTerminalProfile = {
  id: 0,
  name: '',
  employees: [],
};

const defaultItems: TTerminalProfile[] = [];

export const UiSelectTerminalProfile = observer(
  ({
    items = defaultItems,
    value = defaultValue,
    loading = false,
    onChange,
  }: UiSelectTerminalProfile) => {
    const selectValue = useMemo(() => {
      return items.length === 0 ? '' : String(value.id || '');
    }, [items.length, value.id]);

    const handleChange = (value: string) => {
      const foundItem = items.find((item) => Number(item.id) === Number(value));
      if (!foundItem) return;

      onChange(foundItem);
    };

    return (
      <Select
        loading={loading}
        value={selectValue}
        onChange={handleChange}
        style={{ width: '100%' }}
        placeholder="Выберите профиль терминала"
      >
        {items.map((item) => (
          <Select.Option key={String(item.id)} value={String(item.id)}>
            {item.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
);
